<style scoped>
	#app {
		padding: 20px;
	}
	.header {
		line-height: 60px;
		font-size: 16px;
		font-weight: bold;
		
	}
	.table-box {
		margin-top: 10px;
		background-color: white;
		width: 100%;
		border-radius: 3px;
		border:solid 1px #ECECEC;
	}
	
	.table-header {
		padding: 15px 20px;
		font-size: 14px;
		font-weight: bold;
		display: flex;
		flex-direction: row;
		justify-content: space-between;
	}
	
	.box {
		background-color: white;
		width: 100%;
		border-radius: 3px;
		border:solid 1px #ECECEC;
		display: flex;
		flex-wrap: wrap;
		padding: 10px 0;
		font-size: 14px;
	}
	.form-item {
		height: 60px;
		width: 380px;
		display: flex;
		flex-direction: row;
		align-items: center;
	}
	.form-name {
		width: 120px;
		text-align: right;
	}
	.inp {
		width: 280px;
	}
	.el-button--primary {
		background-color: #1677FF!important;
	}
	.dot {
		color: #52C51A;
		padding: 10px;
	}
	.il {
		display: flex;
		flex-direction: row;
	}
	.t-box {
		border: solid 1px #dcdcdc;
		padding: 0 4px;
		border-radius: 4px;
	}
	.t-box1 {
		border: solid 1px #3da113;
		color: #3da113;
		padding: 0 4px;
		border-radius: 4px;
		background-color: #F7FFFE;
	}
	.t-edit {
		font-size: 14px;
		padding: 0 4px;
		margin-left: 10px;
		cursor: pointer;
	}
	.t-a {
		color: #1677FF;
		text-decoration: underline;
		cursor: pointer;
	}
</style>
<template>
	<div id="app">
		<el-breadcrumb class="nav" separator="/" style="margin-bottom: 13px;">
			<el-breadcrumb-item>充值提现</el-breadcrumb-item>
			<el-breadcrumb-item>提现记录</el-breadcrumb-item>
		</el-breadcrumb>
		
		<div class="box">
			<div style="margin-left: 20px; display: flex; flex-direction: row; align-items: center;">
				<div style="margin-left: 10px;">状态：</div>
				<el-select size="mini" v-model="search.status" placeholder="状态" style="width: 120px;">
					<el-option key="all" label="全部" :value="-1"></el-option>
					<el-option key="0" label="待处理" :value="0"></el-option>
					<el-option key="1" label="已同意" :value="1"></el-option>
					<el-option key="2" label="已拒绝" :value="2"></el-option>
				</el-select>
				<div>&nbsp;&nbsp;搜索：</div>
				<el-input size="mini" placeholder="SID / 账号 / 店铺名" v-model="search.keyword" style="margin-right: 10px; width:200px;"></el-input>
				<el-button size="mini" type="primary" @click="getData()">搜索</el-button>
				<el-button size="mini" type="warning" @click="reset()">重置</el-button>
			</div>
		</div>
		
		<div class="table-box">
			<el-table :data="tableData" border 
				v-loading="loading"
				element-loading-text="拼命加载中"
				element-loading-spinner="el-icon-loading"
				element-loading-background="rgba(0, 0, 0, 0.8)" >
			    <el-table-column prop="id" label="序号" align="center" width="80"></el-table-column>
				
				<el-table-column prop="shopInfo" label="店铺名" align="center" width="180">
					<template slot-scope="scope">
						{{scope.row.shopInfo.shop_name}}
					</template>
				</el-table-column>
				<el-table-column prop="sid" label="店主账号(SID)" align="center" width="220">
					<template slot-scope="scope">
						{{scope.row.shopInfo.username}}（{{scope.row.sid}}）
					</template>
				</el-table-column>
				<el-table-column prop="draw_name" label="支付渠道名" align="center" width="140">
					<template slot-scope="scope">
						{{scope.row.payInfo.pay_name}}
					</template>
				</el-table-column>
				<el-table-column prop="draw_name" label="渠道编码" align="center" width="220">
					<template slot-scope="scope">
						{{scope.row.payInfo.pay_code}}
					</template>
				</el-table-column>
				<el-table-column prop="status" label="状态" align="center" width="140">
					<template slot-scope="scope">
						<el-button type="info" v-if="scope.row.status==0" size="mini">待处理</el-button>
						<el-button type="success" v-if="scope.row.status==1" size="mini">已同意</el-button>
						<el-button type="danger" v-if="scope.row.status==2" size="mini">已拒绝</el-button>
						<el-button type="danger" v-if="scope.row.status==3" size="mini">重新进件</el-button>
					</template>
				</el-table-column>
				<el-table-column prop="applyTime" label="申请时间" align="center" width="190">
				</el-table-column>
				<el-table-column prop="actionTime" label="操作时间" align="center" width="190">
				</el-table-column>
				
				<el-table-column prop="remark" label="备注" align="center" width="240">
				</el-table-column>
				
				<el-table-column prop="status" label="操作" fixed="right" align="center" width="200">
					<template slot-scope="scope">
						<el-button type="primary" @click="ActionApply(scope)" size="mini">操作</el-button>
					</template>
				</el-table-column>
				
			  </el-table>
			  
			  <div  style="flex-grow: 1; display: flex; flex-direction: row; justify-content: flex-end; margin: 10px 10px 10px 0;">
			  <el-pagination
			        @size-change="handleSizeChange"
			        @current-change="handleCurrentChange"
			        :current-page="currentPage"
			        :page-sizes="[10, 20, 50, 100]"
			        :page-size="limit"
			        layout="total, sizes, prev, pager, next, jumper"
			        :total="total">
			      </el-pagination>
			  </div>
		</div>
		
		<el-dialog title="操作" :visible.sync="YM_visiable" v-if="YM_visiable" top="50px" width="600px" :before-close="handleClose">
		  <ymApply :Info="actionInfo"></ymApply>
		</el-dialog>
		
		<el-dialog title="操作" :visible.sync="LS_visiable" v-if="LS_visiable" top="50px" width="800px" :before-close="handleClose">
		  <lsApply :Info="actionInfo"></lsApply>
		</el-dialog>
		
		<el-dialog title="操作" :visible.sync="XJ_visiable" v-if="XJ_visiable" top="50px" width="800px" :before-close="handleClose">
		  <xjApply :Info="actionInfo"></xjApply>
		</el-dialog>
	</div> 
</template>

<script>
	import ymApply from './ymApply.vue';
	import lsApply from './lsApply.vue';
	import xjApply from './xjApply.vue';
	export default {
		components:{
			ymApply, lsApply, xjApply
		},
		computed:{
		},
		data(){
			return {
				search:{
					keyword:'',
					status:-1,
				},
				LS_visiable:false,
				YM_visiable:false,
				XJ_visiable:false,
				loading:false,
				currentPage:1,
				tableData: [],
				total:0,
				limit:10,
				actionInfo:{}
			}
		},
		created() {
			this.getData();
		},
		methods:{
			reset(){
				this.search = {
					keyword:'',
					status:-1,
				}
				this.getData();
			},
			ActionApply(scope){
				let _data = scope.row;
				console.log(_data);
				if(_data.payInfo.pay_code.indexOf("alipayYM") === 0){
					this.YM_visiable = true;
					this.actionInfo = _data;
				}else if(_data.payInfo.pay_code.indexOf("alipayLS") === 0){
					this.LS_visiable = true;
					this.actionInfo = _data;
				}else if(_data.payInfo.pay_code.indexOf("alipayXJ") === 0){
					this.XJ_visiable = true;
					this.actionInfo = _data;
				}
			},
			handleClose(){
				this.YM_visiable = false;
				this.LS_visiable = false;
				this.XJ_visiable = false;
			},
			getData(){
				let that = this;
				that.loading = true;
				that.$api.post("/Recharge/getApplyRecordList", {page:this.currentPage, limit:this.limit, ...this.search}).then(res=>{
					that.loading = false;
					that.tableData = res.data.list;
					that.total = res.data.total;
				}).catch(res=>{
					that.loading = false;
				});
			},
			handleSizeChange(e){
				this.limit = e;
				this.getData();
			},
			handleCurrentChange(e){
				this.currentPage = e;
				this.getData();
			}
		}
	}
</script>

